import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TextField } from '@totalsoft/rocket-ui';
import { Table, TableHead, TableRow, TableBody, TableCell, Grid, Typography, Divider } from '@mui/material';

const EngineScoringTestListComponent = ({ scoringTestAttributes }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant='h6'>{t('EngineScoring.Test.AttributesTitle')}</Typography>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('EngineScoring.Test.Name')}</TableCell>
              <TableCell>{t('EngineScoring.Test.Value')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {scoringTestAttributes &&
              scoringTestAttributes &&
              scoringTestAttributes.map((item, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell>
                      <TextField fullWidth value={item.attributeDescription} name={'name'} disabled />
                    </TableCell>
                    <TableCell>
                      <TextField isNumeric fullWidth value={item.attributeValue} name={'value'} disabled />
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

EngineScoringTestListComponent.propTypes = {
  scoringTestAttributes: PropTypes.array.isRequired
};

export default EngineScoringTestListComponent;
